import type { InteractionMetricsSlo, PageLoadMetricsSlo } from './types';

export const isInteractionMetricsSlo = (
	data: InteractionMetricsSlo | PageLoadMetricsSlo,
): data is InteractionMetricsSlo => {
	const obj = data as InteractionMetricsSlo;
	return Boolean(obj.result !== undefined || obj.response !== undefined);
};
